import '.d{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ap{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b8{background:var(--palette-white);}.ssr-plugin'
import '.dv{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.a9{max-width:77.5rem;}.ssr-plugin'
import '.ex{justify-content:stretch;}.ssr-plugin'
import '.b0{position:sticky;}.ssr-plugin'
import '.b1{top:0px;}.ssr-plugin'
import '.b2{z-index:10;}.ssr-plugin'
import '.ey{padding-block:1rem;}.ssr-plugin'
import '.ez{height:3rem;}.ssr-plugin'
import '.bk{justify-content:space-between;}.ssr-plugin'
import '.bw{flex-wrap:wrap;}.ssr-plugin'
import '.f0{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.e7{margin-top:2rem;}.ssr-plugin'
import '.f1{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a2 ap e b8"
      >
        <div className="dv d r ap e"
        >
          <div className="a9 d e ex b0 b1 b2 b8"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ey ez d bk r bw"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="f0 d e a2 e7 f1 a9"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
